import { render, staticRenderFns } from "./MediumCarousel.vue?vue&type=template&id=20e1bcc1"
import script from "./MediumCarousel.vue?vue&type=script&lang=js"
export * from "./MediumCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports